import React from 'react';
import { CalendarClockIcon, HistoryIcon, ArrowUpRightIcon } from 'lucide-react';
import { StatusBar } from './StatusBar';
import { ScreenHeader } from './ScreenHeader';
type Mode = 'schedule' | 'history';
const HISTORY = [{
  id: 'h1',
  name: 'Nimal Silva',
  note: 'Commercial Bank · 8001 •••• 2245',
  date: 'Yesterday · 4:12 PM',
  amount: 'LKR 12,500.00',
  direction: 'out' as const
}, {
  id: 'h2',
  name: 'Salary — ABC Ltd.',
  note: 'Inward credit',
  date: '24 May · 9:02 AM',
  amount: 'LKR 145,000.00',
  direction: 'in' as const
}, {
  id: 'h3',
  name: 'Sunil Perera',
  note: "People's Bank · 0567 •••• 1190",
  date: '21 May · 8:48 PM',
  amount: 'LKR 4,800.00',
  direction: 'out' as const
}];
const SCHEDULED = [{
  id: 's1',
  name: 'Landlord — Mr. Fernando',
  note: 'Sampath Bank · monthly',
  date: 'Next: 1 Jun',
  amount: 'LKR 45,000.00'
}, {
  id: 's2',
  name: 'Insurance Premium',
  note: 'Sri Lanka Insurance · monthly',
  date: 'Next: 5 Jun',
  amount: 'LKR 6,250.00'
}];
export function TransferListScreen({
  mode,
  onBack
}: {
  mode: Mode;
  onBack: () => void;
}) {
  const isSchedule = mode === 'schedule';
  return <div className="relative flex flex-col w-full h-full overflow-hidden" style={{
    backgroundColor: '#F4F7FA'
  }} data-id="element-758">
      <StatusBar data-id="element-759" />
      <ScreenHeader title={isSchedule ? 'Payment Schedule' : 'Payment History'} subtitle={isSchedule ? 'Upcoming automatic transfers' : 'All your recent transfers'} onBack={onBack} data-id="element-760" />
      <div className="flex-1 overflow-y-auto px-5 pb-6" data-id="element-761">
        <div className="mb-3 px-0.5" style={{
        fontSize: 12.5,
        fontWeight: 700,
        color: '#1A1A1A'
      }} data-id="element-762">
          {isSchedule ? 'Scheduled transfers' : 'Recent activity'}
        </div>
        <div className="rounded-2xl bg-white overflow-hidden" style={{
        border: '1px solid #E5EAF0'
      }} data-id="element-763">
          {(isSchedule ? SCHEDULED : HISTORY).map((item, i, arr) => <div key={item.id} className="flex items-center gap-3 px-4 py-3.5" style={{
          borderBottom: i === arr.length - 1 ? 'none' : '1px solid #F1F5F9'
        }} data-id="element-764">
              <span className="shrink-0 flex items-center justify-center rounded-xl" style={{
            width: 40,
            height: 40,
            backgroundColor: isSchedule ? '#EEF2FF' : 'direction' in item && item.direction === 'in' ? '#ECFDF5' : '#E6F7FB',
            color: isSchedule ? '#6366F1' : 'direction' in item && item.direction === 'in' ? '#10B981' : '#009AC7'
          }} data-id="element-765">
                {isSchedule ? <CalendarClockIcon size={18} data-id="element-766" /> : <ArrowUpRightIcon size={18} style={{
              transform: 'direction' in item && item.direction === 'in' ? 'rotate(180deg)' : 'none'
            }} data-id="element-767" />}
              </span>
              <div className="flex-1 min-w-0" data-id="element-768">
                <div className="truncate" style={{
              fontSize: 14,
              fontWeight: 700,
              color: '#1A1A1A'
            }} data-id="element-769">
                  {item.name}
                </div>
                <div className="mt-0.5 truncate" style={{
              fontSize: 11.5,
              color: '#64748B',
              fontWeight: 500
            }} data-id="element-770">
                  {item.note}
                </div>
              </div>
              <div className="text-right" data-id="element-771">
                <div style={{
              fontSize: 13.5,
              fontWeight: 700,
              color: !isSchedule && 'direction' in item && item.direction === 'in' ? '#10B981' : '#1A1A1A'
            }} data-id="element-772">
                  {!isSchedule && 'direction' in item && item.direction === 'in' ? '+ ' : ''}
                  {item.amount}
                </div>
                <div className="mt-0.5" style={{
              fontSize: 11,
              color: '#94A3B8',
              fontWeight: 500
            }} data-id="element-773">
                  {item.date}
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-6 text-center" style={{
        fontSize: 12,
        color: '#64748B',
        fontWeight: 500
      }} data-id="element-774">
          {isSchedule ? <CalendarClockIcon size={14} className="inline mr-1 -mt-0.5" data-id="element-775" /> : <HistoryIcon size={14} className="inline mr-1 -mt-0.5" data-id="element-776" />}
          Showing {(isSchedule ? SCHEDULED : HISTORY).length} of recent items
        </div>
      </div>
      <div className="flex justify-center pb-2" style={{
      backgroundColor: '#F4F7FA'
    }} data-id="element-777">
        <div className="w-[120px] h-[5px] rounded-full bg-neutral-900/80" aria-hidden="true" data-id="element-778" />
      </div>
    </div>;
}